import React, { useEffect, useState } from 'react'
import { fynitoApi } from '../Services/axios';
import { useParams } from 'react-router-dom';
import toastify from '../../helper/toastify';
import { Link } from 'react-router-dom'
import norestimage from '../../assets/images/norestimage.png';
import MobileBottomBar from '../Layout/MobileBottomBar';
import { useSelector } from 'react-redux';

const CategoryRestaurent = () => {
    const { id, name } = useParams();
    const { location } = useSelector((state) => state.location);
    const [catRestaurent, setCatRestaurent] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchCatRestaurent = async () => {
        try {
            setIsLoading(true);
            // Resolve effective lat/long: prefer Redux location, then localStorage, then defaults
            let lat = null;
            let lng = null;
            if (location?.latitude != null && location?.longitude != null) {
                lat = Number(location.latitude);
                lng = Number(location.longitude);
            } else {
                try {
                    const stored = localStorage.getItem('userLocation');
                    if (stored) {
                        const parsed = JSON.parse(stored);
                        if (parsed?.latitude != null && parsed?.longitude != null) {
                            lat = Number(parsed.latitude);
                            lng = Number(parsed.longitude);
                        }
                    }
                } catch (e) {}
            }
            if (lat == null || Number.isNaN(lat)) lat = 26.8828672;
            if (lng == null || Number.isNaN(lng)) lng = 75.7628928;

            const res = await fynitoApi.post('/restaurant-list-to-get-category-for-web', {
                category_id: id,
                lat,
                long: lng,
            });
            if (res.status) {
                setCatRestaurent(res.data.data.data)
            } else {
                toastify("error cat restaturent")
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }
    
    useEffect(() => {
        fetchCatRestaurent();
    }, [id])
    
    return (
        <>
            <section className="bredcump-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        {decodeURIComponent(name)}
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            <section className="favorites-sec tp-space pt-0">
                <div className="container">
                    <div className="row">
                        {isLoading ? (
                            <div className='loading-div'>
                                <div className="row">
                                    {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                                        <div className="col-lg-3 col-md-6 col-sm-6" key={item}>
                                            <div className="swiggy-restaurant-card skeleton-loading">
                                                <div className="swiggy-card-image-container">
                                                    <div className="skeleton-img"></div>
                                                </div>
                                                <div className="swiggy-card-content">
                                                    <div className="skeleton-title"></div>
                                                    <div className="d-flex align-items-center gap-1">
                                                        <div className="skeleton-rating"></div>
                                                        <div className="skeleton-text"></div>
                                                        <div className="skeleton-dot"></div>
                                                        <div className="skeleton-text"></div>
                                                    </div>
                                                    <div className="skeleton-text"></div>
                                                    <div className="skeleton-text"></div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <style jsx>{`
                                    .skeleton-loading {
                                        animation: pulse 1.5s ease-in-out infinite;
                                    }
                                    .skeleton-img {
                                        height: 200px;
                                        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                                        background-size: 200% 100%;
                                        animation: loading 1.5s infinite;
                                        border-radius: 8px 8px 0 0;
                                    }
                                    .skeleton-title {
                                        height: 20px;
                                        background: #f0f0f0;
                                        margin-bottom: 10px;
                                        border-radius: 4px;
                                        width: 80%;
                                    }
                                    .skeleton-text {
                                        height: 15px;
                                        background: #f0f0f0;
                                        margin-bottom: 8px;
                                        border-radius: 4px;
                                        width: 60%;
                                    }
                                    .skeleton-rating {
                                        height: 20px;
                                        width: 20px;
                                        background: #f0f0f0;
                                        border-radius: 50%;
                                    }
                                    .skeleton-dot {
                                        height: 4px;
                                        width: 4px;
                                        background: #f0f0f0;
                                        border-radius: 50%;
                                    }
                                    .skeleton-text:last-child {
                                        width: 70%;
                                    }
                                    @keyframes loading {
                                        0% { background-position: 200% 0; }
                                        100% { background-position: -200% 0; }
                                    }
                                    @keyframes pulse {
                                        0%, 100% { opacity: 1; }
                                        50% { opacity: 0.8; }
                                    }
                                `}</style>
                            </div>
                        ) : catRestaurent?.length > 0 ? (
                            catRestaurent?.map((cat, index) => {
                                return (
                                    <div className="col-lg-3 col-md-6 col-sm-6" key={cat.id}>
                                        <Link to={`/restaurent-list/${cat?.id}`} className="swiggy-card-link">
                                            <div className="swiggy-restaurant-card">
                                                <div className="swiggy-card-image-container">
                                                    <img
                                                        src={cat?.restaurant_image_single || norestimage}
                                                        alt={cat?.restaurant_name || "Restaurant"}
                                                        className="swiggy-card-image"
                                                    />
                                                    {/* Pure Veg Indicator */}
                                                    {cat?.is_veg === "1" && (
                                                        <div className="swiggy-pure-veg-badge">
                                                            <i className="fas fa-leaf" />
                                                            Pure Veg
                                                        </div>
                                                    )}
                                                    {/* Quick Delivery Indicator */}
                                                    {cat?.delivery_time && parseInt(cat.delivery_time) <= 30 && (
                                                        <div className={`swiggy-quick-delivery-badge ${cat?.is_veg === "1" ? 'swiggy-quick-delivery-badge-with-veg' : ''}`}>
                                                            <i className="fas fa-bolt" />
                                                            Quick
                                                        </div>
                                                    )}
                                                    {/* New Restaurant Badge */}
                                                    {cat?.is_new && (
                                                        <div className="swiggy-new-badge">
                                                            <i className="fas fa-star" />
                                                            New
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="swiggy-card-content">
                                                    {/* Restaurant Name */}
                                                    <h5 className="swiggy-restaurant-name" style={{
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        maxWidth: '100%'
                                                    }}>{cat?.restaurant_name}</h5>
                                                    
                                                    {/* Rating with star icon in circle */}
                                                    <div className="d-flex align-items-center gap-1">
                                                        <span className="swiggy-rating-container swiggy-rating">
                                                            <i className="fas fa-star" />
                                                        </span>
                                                        <span className="swiggy-delivery-time"> {cat?.rating?.toFixed(1)}</span>
                                                        <i className="fas fa-circle" style={{fontSize: '4px'}} /> 
                                                        <span className="swiggy-delivery-time">{cat?.delivery_time}</span>
                                                    </div>
                                                    
                                                    <div className="food-items-serving-container">
                                                        <span className="swiggy-delivery-time" style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            maxWidth: '100%',
                                                            display: 'block'
                                                        }}>
                                                            {cat?.category && cat.category.length > 0 
                                                                ? cat.category.map((catItem, index) => catItem.title).join(', ')
                                                                : '--'
                                                            }
                                                        </span>
                                                    </div>
                                                    
                                                    {/* Location area name */}
                                                    <div className="swiggy-location">
                                                        <span className="swiggy-distance">
                                                            <i className="fas fa-map-marker-alt" />
                                                            {cat?.city || 'Unknown Area'}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )
                            })
                        ) : (
                            <div className='no-rest-found-div'>
                            <p className='text-center text-danger h4 d-flex align-items-center justify-content-center'>No Restaurant Found</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            {/* Mobile Bottom Bar */}
            <MobileBottomBar />
        </>
    )
}

export default CategoryRestaurent